import { Pencil } from 'lucide-react';
import { Avatar } from '../../../../../design-system/avatar/avatar/avatar';
import { Button } from '../../../../../design-system/button/button';
import { DrawerClose, DrawerDescription, DrawerHeader, DrawerTitle } from '../../../../../design-system/drawer/drawer';
import { Inline } from '../../../../../design-system/inline/inline';
import { Stack } from '../../../../../design-system/stack/stack';
import { getVendorLogo } from '../../../../../pages/accounts/utils/get-vendor-details';
import { VendorView } from '../../../../../types/entity-types';

type HeaderProps = {
  vendor: VendorView;
  onEditVendor?: () => void;
  onClose?: () => void;
};

export const Header = ({ vendor, onEditVendor, onClose }: HeaderProps) => {
  const vendorLogo = getVendorLogo(vendor.name, vendor.logo);

  return (
    <DrawerHeader className="flex w-full items-center rounded-lg bg-muted py-10">
      <Stack className="w-full" space={5} justify="center" align="center">
        <Stack align="center" justify="start" space={2}>
          <Avatar name={vendor.name} avatarUrl={vendorLogo} size="lg" />
          <DrawerTitle>
            <div className="text-base font-medium">{vendor.name}</div>
          </DrawerTitle>
        </Stack>

        <DrawerDescription>
          <Inline space={2} align="center">
            <Button
              variant="secondary"
              className="bg-white hover:bg-accent"
              onClick={onEditVendor}
              iconLeft={<Pencil size={16} />}
            >
              Edit Vendor
            </Button>
          </Inline>
        </DrawerDescription>

        <DrawerClose onClick={onClose} />
      </Stack>
    </DrawerHeader>
  );
};
